import React, { useEffect, useCallback } from 'react';
import { LoadingScreen } from './LoadingScreen';
import { apiClientState } from '../features/api';
import { useRecoilValue, useRecoilState } from 'recoil';
import { configState } from '../features/config';
import { tokensState, persistState } from '../features/auth';
import { GrantType } from '@oh-auth/dto';

interface RefreshTokensProps {
	onRefreshed: () => any;
}

export function RefreshTokens(props: RefreshTokensProps) {
	const { onRefreshed } = props;
	const apiClient = useRecoilValue(apiClientState);
	const config = useRecoilValue(configState);
	const [tokens, setTokens] = useRecoilState(tokensState);
	const persist = useRecoilValue(persistState);

	const refreshTokens = useCallback(
		(cb: () => any) => {
			if (!tokens) return;
			const { refresh_token } = tokens;

			if (refresh_token) {
				apiClient
					.getTokens(null, {
						grant_type: GrantType.REFRESH_TOKEN,
						refresh_token,
						client_id: config.CLIENT_ID,
					})
					.then((tokens) => {
						setTokens(tokens);
						if (persist) {
							localStorage.setItem(
								'tokens',
								JSON.stringify(tokens)
							);
						} else {
							sessionStorage.setItem(
								'tokens',
								JSON.stringify(tokens)
							);
						}
						cb();
					})
					.catch(() => {
						setTokens(null);
					});
			}
		},
		[apiClient, tokens, config.CLIENT_ID, setTokens, persist]
	);

	useEffect(() => {
		refreshTokens(onRefreshed);
	}, [refreshTokens, onRefreshed]);

	return <LoadingScreen />;
}
